<template>
    <div class="activity-report-wrapper">
        <div class="container-xxl padding-container-matrix">
            <div class="row justify-content-center">
                <div class="col-matrix">
                    <div class="accordion accordion-documents" id="accordion-documents">
                        <div class="row pt-4">

                            <div class="col-12 col-md-4 mb-5">
                                <h6 v-if="sectionBlock.sectionTitle" class="text-weight-regular text-uppercase">{{sectionBlock.sectionTitle}}</h6>
                                <p v-if="sectionBlock.sectionSubTitle">{{sectionBlock.sectionSubTitle}}</p>


                                <button
                                    v-if="sectionBlock.pdfDocument.length > 3"
                                    class="accordion-button collapsed mt-4"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#accordion-document-content"
                                    aria-expanded="false"
                                    aria-controls="#accordion-document-content"
                                >
                                    {{sectionBlock.btnText}}
                                </button>

                            </div>

                            <div class="col-12 col-md-auto offset-md-1">
                                <div
                                    v-for="(doc, index) in sectionBlock.pdfDocument.slice(0,3)"
                                    :key="'doc-' + index"

                                >
                                    <a :href="doc.document" target="_blank" class="document-link">{{doc.documentTitle}}</a>
                                </div>

                                <div
                                    v-if="sectionBlock.pdfDocument.length > 3"
                                    id="accordion-document-content"
                                    class="accordion-collapse collapse"

                                    data-bs-parent="accordion-documents"
                                >
                                    <div class="accordion-body">
                                        <div
                                            v-for="(doc, index) in sectionBlock.pdfDocument.slice(3,-1)"
                                            :key="'doc-content-' + index"
                                        >
                                            <a :href="doc.document" target="_blank" class="document-link">{{doc.documentTitle}}</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'

// Import bootstrap tabs & accordions
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/collapse'

// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'activityReport',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        yearsPassed(oldDate) {
            const today = dayjs(new Date())
            return today.diff(oldDate, 'year')
        },
    },
    // On loaded...
    mounted() {},
}
</script>
